<template>
  <div class="select is-fullwidth">
    <!-- eslint-disable-next-line vuejs-accessibility/form-control-has-label -->
    <select v-model="value">
      <option
        v-for="(option, i) in options"
        :key="option.value || i"
        :value="option.value"
      >
        {{ option.label }}
      </option>
    </select>
  </div>
</template>

<script lang="ts" setup>
import type { FieldSelectOption } from './types'

defineProps<{
  options: FieldSelectOption[]
}>()

const value = defineModel<string>()
</script>
